import React from 'react';
import { bool, shape, string } from 'prop-types';

const StatusCanceledColor = ({
  className = '',
  notUseClass = false,
  color = '#cf3537',
  style = {},
}) => (
  <svg className={notUseClass ? '' : className} style={{ color, ...style }} width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M7.49996 1.16663C4.27413 1.16663 1.66663 3.77413 1.66663 6.99996C1.66663 10.2258 4.27413 12.8333 7.49996 12.8333C10.7258 12.8333 13.3333 10.2258 13.3333 6.99996C13.3333 3.77413 10.7258 1.16663 7.49996 1.16663ZM7.49996 11.6666C4.92746 11.6666 2.83329 9.57246 2.83329 6.99996C2.83329 4.42746 4.92746 2.33329 7.49996 2.33329C10.0725 2.33329 12.1666 4.42746 12.1666 6.99996C12.1666 9.57246 10.0725 11.6666 7.49996 11.6666ZM7.49996 6.17746L9.59413 4.08329L10.4166 4.90579L8.32246 6.99996L10.4166 9.09413L9.59413 9.91663L7.49996 7.82246L5.40579 9.91663L4.58329 9.09413L6.67746 6.99996L4.58329 4.90579L5.40579 4.08329L7.49996 6.17746Z" fill="currentColor" />
  </svg>
);

StatusCanceledColor.propTypes = {
  className: string,
  notUseClass: bool,
  color: string,
  style: shape({}),
};

export default StatusCanceledColor;
